import { apiCallPost } from "../api"
import { apiPaths } from "../config/apiPaths";

export const submitReportApi = async (inputData, authHeaders) => {
  const { issueTitle, details, attachment } = inputData;
  
  const apiInputData = {
    issueTitle,
    details: details || '',
    ...(attachment && { attachment })
  };

  try {
    const res = await apiCallPost(apiPaths.reportIssue, apiInputData, authHeaders);
    
    if (res?.success === true) {
      return {
        data: res.id || res.data,
        status: true,
        msg: res.message || "Your report has been submitted successfully. Thank you for helping us improve!"
      };
    }
    
    return {
      data: null,
      status: false,
      msg: res?.message || res?.msg || "Error submitting report. Please try again."
    };
  } catch (err) {
    return { status: false, errMsg: err.message };
  }
};

